export default "__VITE_PUBLIC_ASSET__a64b876b__"